<template>
	<div>
		<span
			v-if="tradable.extra.contract != null && tradable.extra.contract != ''"
		>
			{{
				$cropOptions.getLocalizedLabel(
					tradable.extra.contract,
					$cropOptions.contractOptions
				)
			}}
		</span>
		<span v-else>
			{{ __("Einheitsbedingungen in Anlehnung an Aufkaufbedingungen") }}
		</span>
		<br />

		<span
			v-if="
				tradable.extra.payment_terms != null &&
				tradable.extra.payment_terms != ''
			"
		>
			{{
				$cropOptions.getLocalizedLabel(
					tradable.extra.payment_terms,
					$cropOptions.paymentTermsOptions
				)
			}}
		</span>
		<span v-else>
			{{ __("Netto Kasse gegen Liefernachweis") }}
		</span>
		<br />

		<span
			v-if="
				tradable.extra.payment_mode != null && tradable.extra.payment_mode != ''
			"
		>
			{{
				$cropOptions.getLocalizedLabel(
					tradable.extra.payment_mode,
					$cropOptions.paymentModeOptions
				)
			}}
		</span>
		<span v-else>
			{{ __("Gutschrift") }}
		</span>

		<p v-if="tradable.extra.average_across_deliveries" class="pt-2">
			{{ __("Billing in the average of the total lot") }}
		</p>

		<p v-if="tradable.extra.text" class="pt-2">
			{{ __("Conditions of purchase Alt") }}: {{ tradable.extra.text }}
		</p>

		<p v-if="tradable.variety_protection_enabled" class="pt-2">
			<span
				>{{ __("EU Plant Variety Protection") }}
				<ui-tooltip
					class="text-green-400 whitespace-normal"
					:icon-stroke-width="2"
					icon-class="ml-1 w-4 h-4"
					:text="euVarietyProtectionInfo"
			/></span>
		</p>
	</div>
</template>

<script>
export default {
	props: {
		tradable: {
			type: Object,
			required: true,
		},
	},
	computed: {
		euVarietyProtectionInfo: function () {
			return this.__("eu_variety_protection_info");
		},
	},
};
</script>
